export default "__VITE_PUBLIC_ASSET__fb1c6776__"